var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FeedbackWrapper",
    {
      staticClass: "mercado-indicadores",
      attrs: {
        loading: _vm.loading,
        message: _vm.WALLET_EMPTY_MESSAGE,
        minHeight: _vm.loading ? "100%" : _vm.cardMinHeight,
        bordered: ""
      }
    },
    [
      _c(
        "div",
        { staticClass: "mercado-indicadores__card az-card-bordered" },
        [
          _c("div", { staticClass: "mercado-indicadores__header" }, [
            _c("div", { staticClass: "az-ds-card-title" }, [
              _vm._v(" Mercado ")
            ]),
            _c("span", { staticClass: "az-text-small" }, [
              _vm._v(" " + _vm._s(_vm.referencePeriod) + " ")
            ])
          ]),
          _c("v-data-table", {
            staticClass: "mercado-indicadores__table table-new-ux-v1",
            attrs: {
              headers: _vm.tableHeaders,
              items: _vm.sortedIndicators,
              height: _vm.contentHeight,
              "fixed-header": "",
              "disable-pagination": "",
              "hide-default-footer": ""
            },
            scopedSlots: _vm._u([
              {
                key: "item.rentabilidade",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    typeof item.rentabilidade === "number"
                      ? _c("GeneralValueDiff", {
                          staticStyle: {
                            margin: "0 !important",
                            "font-size": "12px"
                          },
                          attrs: {
                            value: item.rentabilidade,
                            "value-formatted": _vm.toDecPercent(
                              item.rentabilidade
                            )
                          }
                        })
                      : _c("span", [_vm._v(" - ")])
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }